import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from "@bt/shared";


import { CreateAdminComponent } from './create-admin.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    FontAwesomeModule
  ],
  declarations: [
    CreateAdminComponent
  ],
})
export class CreateAdminModule { }


// WEBPACK FOOTER //
// ./src/app/superadmin/create-admin/create-admin.module.ts